import AuthorityBasicInformation from './AuthorityBasicInformation';

export default AuthorityBasicInformation;
